import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { Eye, Send } from "lucide-react";
import { api, errMsg, fmtDate } from "@/lib/api";
import { Panel } from "@/components/admin/AdminLayout";

export const DigestPanel = ({ isAdmin, connected }) => {
  const [busy, setBusy] = useState(false);
  const { data, refetch } = useQuery({ queryKey: ["digest"], queryFn: () => api.post("/admin/digest/preview").then((r) => r.data) });
  const send = async () => {
    if (!window.confirm("Post the digest to your Telegram channel now?")) return;
    setBusy(true);
    try { const r = (await api.post("/admin/digest/send-now")).data; toast.success(r.message); refetch(); } catch (e) { toast.error(errMsg(e), { duration: 9000 }); } finally { setBusy(false); }
  };
  if (!data) return null;
  return (
    <Panel title="Daily 'Top deals' digest" testid="digest-panel">
      <p className="text-sm" data-testid="digest-status">
        <b className={data.enabled ? "text-emerald-700" : "text-slate-500"}>{data.enabled ? `On - every day at ${data.time}` : "Off"}</b>
        <span className="text-slate-500"> · last sent {data.last_sent ? fmtDate(data.last_sent) : "never"} · switch on and set the time in Settings → Social posting.</span>
      </p>
      <p className="text-xs text-slate-500 mt-1">Picks the highest-score published deals from the last 24 hours (72 if needed), one per store.</p>
      {data.deals.length ? (
        <ol className="list-decimal pl-5 mt-3 space-y-1 text-sm" data-testid="digest-preview-list">
          {data.deals.map((d) => <li key={d.id}>{d.title} <span className="text-slate-500">· {d.merchant_name} · score {d.score}</span></li>)}
        </ol>
      ) : <p className="text-sm text-amber-700 mt-3" data-testid="digest-empty">No fresh published deals right now - the digest will be skipped.</p>}
      <div className="flex gap-2 mt-4">
        <button onClick={() => refetch()} className="px-3 py-2 rounded-lg border text-sm font-bold flex items-center gap-1.5" data-testid="digest-refresh-button"><Eye size={15} /> Refresh preview</button>
        {isAdmin && <button disabled={busy || !connected || !data.deals.length} onClick={send} className="px-3 py-2 rounded-lg bg-sky-600 text-white text-sm font-bold flex items-center gap-1.5 disabled:opacity-40" data-testid="digest-send-now-button"><Send size={15} /> Send now</button>}
      </div>
    </Panel>
  );
};
